import React from 'react'
import ZipPayment from '../ZipPayment'
import PayPalPayment from '../PayPalPayment'

const Payment = ({
  totalAfterTax,
  isDesktop,
  isWmoEnabled = false,
  showZip,
  showPaypalLater,
}) => (
  <>
    {isWmoEnabled && showPaypalLater && (
    <PayPalPayment totalAfterTax={totalAfterTax} isDesktop={isDesktop} />
    )}
    {isWmoEnabled && showZip && <ZipPayment totalAfterTax={totalAfterTax} />}

    {!isWmoEnabled && (
    <PayPalPayment totalAfterTax={totalAfterTax} isDesktop={isDesktop} />
    )}
    {!isWmoEnabled && <ZipPayment totalAfterTax={totalAfterTax} />}
  </>
)

export default Payment
